

class LatestWins {
  constructor(sendFn) {
    this.sendFn = sendFn;
    this.inFlight = false;
    this.destroyed = false;
    this._pendingBatch = null;
  }

  schedule(...args) {
    if (this.destroyed) {
      return Promise.reject(new Error("LatestWins is destroyed"));
    }

    if (this._pendingBatch) {
      this._pendingBatch.args = args;
    } else {
      this._pendingBatch = { args, waiters: [] };
    }

    const p = new Promise((resolve, reject) => {
      this._pendingBatch.waiters.push({ resolve, reject });
    });

    this.maybeRun();
    return p;
  }

  destroy() {
    this.destroyed = true;
    if (this._pendingBatch) {
      const { waiters } = this._pendingBatch;
      this._pendingBatch = null;
      waiters.forEach(w => w.reject(new Error("LatestWins destroyed")));
    }
  }

  maybeRun() {
    if (this.inFlight || this.destroyed || !this._pendingBatch) return;
    this.inFlight = true;
    this.runLoop();
  }

  async runLoop() {
    try {
      while (!this.destroyed && this._pendingBatch) {
        const { args, waiters } = this._pendingBatch;
        this._pendingBatch = null;

        try {
          const result = await this.sendFn(...args);
          waiters.forEach(w => w.resolve(result));
        } catch (e) {
          console.error("LatestWinsScheduler send error:", e);
          waiters.forEach(w => w.reject(e));
        }
      }
    } finally {
      this.inFlight = false;
      if (!this.destroyed && this._pendingBatch) this.maybeRun();
    }
  }
}

export default { LatestWins };
